var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "sell-wrapper",
      on: { mousedown: _vm.allowTextSelection },
    },
    [
      !_vm.isFullScreen()
        ? [
            _c("div", { staticClass: "sell-header-slideBar" }, [
              _vm._m(0),
              _c("div", { staticClass: "sell-close-slideBar" }, [
                _c("img", {
                  staticClass: "sell-close-slideBar-icon",
                  attrs: {
                    src: require("@/assets/image/aigc/close.png"),
                    alt: "",
                  },
                  on: { click: _vm.close },
                }),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "sell-select-slideBar" },
              [
                _c(
                  "el-input",
                  {
                    staticClass: "input-search",
                    attrs: { placeholder: "请输入关键词", clearable: "" },
                    on: { change: _vm.changeCollect },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.enterSearch.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.searhcQuery.cueWord,
                      callback: function ($$v) {
                        _vm.$set(_vm.searhcQuery, "cueWord", $$v)
                      },
                      expression: "searhcQuery.cueWord",
                    },
                  },
                  [
                    _c("template", { slot: "prefix" }, [
                      _c("img", {
                        staticClass: "input-search-icon",
                        attrs: {
                          src: require("@/assets/image/aigc/search.png"),
                          alt: "",
                        },
                        on: { click: _vm.enterSearch },
                      }),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        : [
            _c("div", { staticClass: "sell-header-full-screen" }, [
              _c(
                "div",
                { staticClass: "tools-btns" },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "bottom",
                        title: "猜你想要",
                        trigger: "hover",
                        "popper-class": "custom-chat-tools-popover",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn-tool",
                          attrs: { slot: "reference" },
                          on: { click: _vm.trigger },
                          slot: "reference",
                        },
                        [_vm._v("猜")]
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "divider" }),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "bottom",
                        title: "我的收藏",
                        trigger: "hover",
                        "popper-class": "custom-chat-tools-popover",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn-tool btn-tool-select",
                          attrs: { slot: "reference" },
                          slot: "reference",
                        },
                        [_vm._v("藏")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("p", { staticClass: "icons flex" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/image/aigc/slidebar.png"),
                    alt: "",
                  },
                  on: { click: _vm.closeFullScreen },
                }),
                _c("img", {
                  attrs: {
                    src: require("@/assets/image/aigc/close.png"),
                    alt: "",
                  },
                  on: { click: _vm.closeALL },
                }),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "full-search" },
              [
                _vm._m(1),
                _c(
                  "el-input",
                  {
                    staticClass: "input-search input-search-full",
                    attrs: { placeholder: "请输入关键词", clearable: "" },
                    on: { change: _vm.changeCollect },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.enterSearch.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.searhcQuery.cueWord,
                      callback: function ($$v) {
                        _vm.$set(_vm.searhcQuery, "cueWord", $$v)
                      },
                      expression: "searhcQuery.cueWord",
                    },
                  },
                  [
                    _c("template", { slot: "prefix" }, [
                      _c("img", {
                        staticClass: "input-search-icon",
                        attrs: {
                          src: require("@/assets/image/aigc/search.png"),
                          alt: "",
                        },
                        on: { click: _vm.enterSearch },
                      }),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
      _c(
        "div",
        {
          directives: [
            {
              name: "infinite-scroll",
              rawName: "v-infinite-scroll",
              value: _vm.loadmore,
              expression: "loadmore",
            },
          ],
          class: {
            "sell-content": true,
            "sell-content-full-screen": _vm.isFullScreen(),
          },
          attrs: { "infinite-scroll-disabled": _vm.disabledInfiniteScroll },
        },
        [
          _vm._l(_vm.list, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                ref: "collectWrapper",
                refInFor: true,
                class: {
                  "sell-collert-item": true,
                  "sell-collert-item-more": item.isMore,
                },
                on: { mouseenter: (e) => _vm.isOpenMore(e, index) },
              },
              [
                _c("div", { staticClass: "sell-collert-top" }, [
                  _c("div", { staticClass: "sell-collert-item-title" }, [
                    _c("span", { staticClass: "item-title-s" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                  ]),
                  _c("span", { staticClass: "edit-span" }, [
                    _vm._v(" 点击可编辑发送 "),
                  ]),
                  _c("img", {
                    staticClass: "img-collect",
                    attrs: {
                      src: require("@/assets/image/aigc/collect-select.png"),
                      alt: "",
                      title: "取消收藏",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.cancel(item, index)
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "sell-collert-item-content",
                    on: {
                      click: function ($event) {
                        return _vm.selectItem(item)
                      },
                    },
                  },
                  [_c("span", { domProps: { innerHTML: _vm._s(item.text) } })]
                ),
                !item.isMore
                  ? _c("div", { staticClass: "hover-open-more" }, [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.more(item)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-arrow-down" }),
                          _vm._v("展开"),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          _vm.list.length < 1
            ? _c("el-empty", {
                attrs: { "image-size": 100, description: "暂无数据" },
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sell-title-slideBar" }, [
      _c("img", {
        staticClass: "sell-title-icon",
        attrs: { src: require("@/assets/image/aigc/collect.png"), alt: "" },
      }),
      _c("span", [_vm._v("我的收藏")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex" }, [
      _c("img", {
        staticClass: "sell-title-icon",
        attrs: { src: require("@/assets/image/aigc/collect.png"), alt: "" },
      }),
      _c("span", [_vm._v("我的收藏")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }